module.exports = __webpack_public_path__ + "img/driver.5e15a00c.png";